/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_service_approval': {
    width: 23,
    height: 19,
    viewBox: '0 0 23 19',
    data: '<defs><path pid="0" d="M22.679 11.98h-2.956V5.995H3.956v9.978h4.927v2.994H1V3h21.679v8.98zm-5.42 3.992c-.816 0-1.478-.67-1.478-1.496 0-.827.662-1.497 1.478-1.497.817 0 1.478.67 1.478 1.497 0 .826-.661 1.496-1.478 1.496zm-2.927-.029l1.811 1.812-4.233 4.234-1.812-1.812 4.234-4.234zm5.46 0l4.234 4.234-1.811 1.812-4.234-4.234 1.812-1.812z" id="svgicon_icon_service_approval_a"/></defs><g transform="translate(-1 -3)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_service_approval_b" _fill="#fff"><use xlink:href="#svgicon_icon_service_approval_a"/></mask><use _fill="#000" xlink:href="#svgicon_icon_service_approval_a"/><g mask="url(#svgicon_icon_service_approval_b)" _fill="#A156DD"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_service_approval.js